import script from "./ActivatorsAccordionFAQ.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivatorsAccordionFAQ.vue?vue&type=script&setup=true&lang=ts"

import "./ActivatorsAccordionFAQ.vue?vue&type=style&index=0&id=6e7ae3cb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e7ae3cb"]])

export default __exports__